"use strict";
/**
 * RedPanda UI - Utilities
 * 共用工具函數
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cn = cn;
const clsx_1 = require("clsx");
/**
 * 合併 className 的工具函數
 * 使用 clsx 來處理條件式 className
 */
function cn(...inputs) {
    return (0, clsx_1.clsx)(inputs);
}
